// extracted by mini-css-extract-plugin
export default {"inspection":"Inspection_inspection__sFoFj","box":"Inspection_box__69xvi","buttons":"Inspection_buttons__hvpk3","newGameButton":"Inspection_newGameButton__hzbtl"};